export class GameTopic {
    static GAME_START:string = 'GAME_START';
    static LEVEL_RESET:string = 'LEVEL_RESET';
    static LEVEL_END:string = 'LEVEL_END';
    static INSTRUCTION_CLOSE:string = 'INSTRUCTION_CLOSE';

    static INVENTORY_IN_POSITION:string = 'INVENTORY_IN_POSITION';
    static INVENTORY_ANIMATION_DONE:string = 'INVENTORY_ANIMATION_DONE';

    static CONTACT:string = 'CONTACT';

    static SWITCH:string = 'SWITCH';
}



// WEBPACK FOOTER //
// ./src/GameTopic.ts